import React from "react";
import Introduction from "./utils/Introduction";
import Mission2 from "./utils/Mission2";
import Mission3 from "./utils/Mission3";
import End from "./utils/End";

export function BookFinderApp(props) {
  return (
    <div className="challenge-details container">
      <Introduction track="Software Engineer" logo={props.logo} />
      <h2 className="mission-1">
        Mission 1: Create a <strong>BookFinder App</strong>
      </h2>
      <h3>Description</h3>
      <ul>
        <li>
          An application where users can search for books by entering a query.
          It should contain at least 2 pages:
          <br />
          <ul>
            <li>
              {" "}
              Where you can add new book(title of the book, author, published
              date)
            </li>
            <li>
              Where you can see the list of all books and user can enter a
              search query into an input field.
            </li>
          </ul>
        </li>
        <li>
          You should have a separate backend for handling the storage
        </li>
      </ul>
      <h3>Rules</h3>
      <ul>
        <li>Write your solution in the language and framework you want</li>
        <li>You may use packages</li>
      </ul>
      <Mission2 track="SE Engineer" />
      <Mission3 notes="you can  write some notes to us. These notes can be anything you would like us to know, especially for technical decisions. They are not mandatory, so you can also skip this this parameter." />
      <End />
    </div>
  );
}
